import { createRoute } from "@tanstack/react-router";
import { withPermission } from "../lib/with-permission";
import { rootRoute } from "./__root";
import { OrderFormPage } from "./orders.new";

function OrderEditPage() {
	const { id } = route.useParams();
	return <OrderFormPage editId={id} />;
}

export const route = createRoute({
	getParentRoute: () => rootRoute,
	path: "/orders/$id/edit",
	component: withPermission(OrderEditPage, "orders", "update"),
});
